import { render, staticRenderFns } from "./TemplatesEditQuick.vue?vue&type=template&id=63ff7707&scoped=true&"
import script from "./TemplatesEditQuick.vue?vue&type=script&lang=js&"
export * from "./TemplatesEditQuick.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesEditQuick.vue?vue&type=style&index=0&id=63ff7707&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff7707",
  null
  
)

export default component.exports